import React from 'react';

const DISCCircle = ({ primaryStyle, blend, size = 200 }) => {
  const colors = {
    D: '#D32F2F',
    I: '#F58820',
    S: '#1976D2',
    C: '#FBC02D',
  };

  const positions = {
    D: { angle: -135, label: 'D', sublabel: 'Dominant' },
    I: { angle: -45, label: 'I', sublabel: 'Inspiring' },
    S: { angle: 45, label: 'S', sublabel: 'Supportive' },
    C: { angle: 135, label: 'C', sublabel: 'Cautious' },
  };

  const center = size / 2;
  const radius = size / 2 - 30;

  // Calculate position from center for a style marker
  const getPositionForStyle = (style, distance = 0.7) => {
    const pos = positions[style];
    const angleRad = (pos.angle * Math.PI) / 180;
    return {
      x: center + Math.cos(angleRad) * radius * distance,
      y: center + Math.sin(angleRad) * radius * distance,
    };
  };

  const primaryPos = getPositionForStyle(primaryStyle, 0.5);

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Background circle */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      {/* Quadrant arcs */}
      {Object.entries(positions).map(([style, pos]) => {
        const startAngle = pos.angle - 45;
        const endAngle = pos.angle + 45;
        const startRad = (startAngle * Math.PI) / 180;
        const endRad = (endAngle * Math.PI) / 180;

        const x1 = center + Math.cos(startRad) * radius;
        const y1 = center + Math.sin(startRad) * radius;
        const x2 = center + Math.cos(endRad) * radius;
        const y2 = center + Math.sin(endRad) * radius;

        const largeArcFlag = 0;

        return (
          <path
            key={style}
            d={`M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`}
            fill={colors[style]}
            opacity={primaryStyle === style ? 0.8 : 0.3}
            stroke="white"
            strokeWidth="2"
          />
        );
      })}

      {/* Style labels */}
      {Object.entries(positions).map(([style, pos]) => {
        const labelPos = getPositionForStyle(style, 0.75);
        return (
          <g key={`label-${style}`}>
            <text
              x={labelPos.x}
              y={labelPos.y}
              textAnchor="middle"
              dominantBaseline="middle"
              fill="white"
              fontSize="24"
              fontWeight="bold"
              fontFamily="Inter, sans-serif"
            >
              {style}
            </text>
          </g>
        );
      })}

      {/* Primary style marker */}
      <circle
        cx={primaryPos.x}
        cy={primaryPos.y}
        r="12"
        fill="#ffffff"
        stroke={colors[primaryStyle]}
        strokeWidth="3"
      />

      {/* Center circle */}
      <circle
        cx={center}
        cy={center}
        r="20"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#374151"
        fontSize="10"
        fontWeight="bold"
        fontFamily="Inter, sans-serif"
      >
        {blend || primaryStyle}
      </text>

      {/* Axis labels */}
      <text
        x={center}
        y="12"
        textAnchor="middle"
        fill="#6b7280"
        fontSize="10"
        fontFamily="Inter, sans-serif"
      >
        OUTGOING
      </text>
      <text
        x={center}
        y={size - 6}
        textAnchor="middle"
        fill="#6b7280"
        fontSize="10"
        fontFamily="Inter, sans-serif"
      >
        RESERVED
      </text>
      <text
        x="8"
        y={center}
        textAnchor="start"
        dominantBaseline="middle"
        fill="#6b7280"
        fontSize="10"
        fontFamily="Inter, sans-serif"
        transform={`rotate(-90, 10, ${center})`}
      >
        TASK
      </text>
      <text
        x={size - 8}
        y={center}
        textAnchor="end"
        dominantBaseline="middle"
        fill="#6b7280"
        fontSize="10"
        fontFamily="Inter, sans-serif"
        transform={`rotate(90, ${size - 10}, ${center})`}
      >
        PEOPLE
      </text>
    </svg>
  );
};

export default DISCCircle;
